import { makeObservable, observable, computed } from "mobx"
import Debrief from "./Debrief";

import ActivityResult from './ActivityResult'

export const STATES = {
  CORRECT: "CORRECT",
  WRONG: "WRONG",
  MISSED: "MISSED",
}

class ActivityPedaInstance
{
  /** @type {ActivityResult} */
  result = null

  /** @type {Array<Debrief>} */
  debriefs = []

  ID
  Text = ""

  media
  Type
  jokerUsed = false

  addDebrief(json, isCorrect) {
    let newDebrief = new Debrief(json, isCorrect)
    this.debriefs = [...this.debriefs, newDebrief]
  }

  localCorrect() { console.log("localCorrect: OVERRIDE ME !"); }

  /** @param {ActivityResult} result*/
  setResult(result) {
    if(!result instanceof ActivityResult) {
      result = new ActivityResult().fromJson(result)
    }
    this.result = result
  }

  /** @returns {Array} */
  getAnswer()  { console.log("getAnswer: OVERRIDE ME !"); }
  useJoker()   { console.log("useJoker: OVERRIDE ME !"); }


  // NOTE override ceci pour retourner un truc custom (null si on ne veut pas l'afficher, ou gérer l'affichage ailleurs dans le component Game par exemple)
  getDebrief() {
    // ici on renvoie le debrief qu'il faut
    if(this.debriefs.length === 0) return null

    if(this.debriefs.length === 1) return this.debriefs[0]

    if(this.debriefs.length === 2) {
      if(!this.result) return this.debriefs.find(d => d.isCorrect)

      if(this.result.is_correct) {
        return this.debriefs.find(d => d.isCorrect)
      }
      else {
        return this.debriefs.find(d => !d.isCorrect)
      }
    }

    return null

  }

  get jokerAvailable() {
    // NOTE renvoyer true si la question peut permettre l'utilisation d'un joker. Par exemple, ce n'est pas possible pour un qcm avec 2 choix, cela donnerait automatiquement la bonne réponse.
    // A override dans les classes enfant
    console.log("jokerAvailable : OVERRIDE ME !!!")
    return false
  }

  reset() {
    console.log("reset() : OVERRIDE ME !!!")
  }

  /**
   * Renvoie l'état actuel de l'activité.
   * L'idée est de pouvoir sauvegarder l'état et de remettre dans le même état via la sauvegarde ou autre chose, donc ça doit être
   * cohérent avec le fonctionnement de setState()
   * Cette fonction ne renvoie que this.result et this.jokerUsed, il faut que les sous-classe implémente une version de cette fonction qui retourne des data supplémentaires si besoin
   */
  getState() {
    return {
      result : this.result,
      jokerUsed : this.jokerUsed
    }
  }
  /**
   * Permet de remettre l'activité dans un état donné.
   * L'idée est de pouvoir reprendre l'activité dans un état bien précis via la sauvegarde ou autre chose, donc ça doit être
   * cohérent avec le fonctionnement de getState()
   * Cette fonction ne gère que this.result et this.jokerUsed, il faut que les sous-classe implémente une version de cette fonction qui gère des data supplémentaires si besoin
   */
  setState(state) {
    this.setResult(state.result)
    this.jokerUsed = state.jokerUsed
  }

  fromJson(json) {
    Object.assign(this, json)
    return this
  }


  observe() {
    makeObservable(this, {
      Text: observable,
      media: observable,
      result: observable,
      debriefs: observable,
      jokerUsed: observable,

      jokerAvailable: computed
    })
  }
}


export default ActivityPedaInstance